export type RecaptchaV3Client = {
	ready: (callback: () => void) => void;
	execute: (siteKey: string, options: ReCaptchaV2.Action) => PromiseLike<string>;
};

export type BoundedRecaptchaTokenOptions = {
	siteKey: string;
	action: string;
	timeoutMs?: number;
	onTimeout?: () => void;
	onError?: (error: unknown) => void;
};

const DEFAULT_TIMEOUT_MS = 8000;

export async function getBoundedRecaptchaToken(
	client: RecaptchaV3Client,
	options: BoundedRecaptchaTokenOptions,
): Promise<string | null> {
	return new Promise(resolve => {
		let isSettled = false;
		let timeoutId = 0;
		const settle = (token: string | null) => {
			if (isSettled) {
				return;
			}

			isSettled = true;
			window.clearTimeout(timeoutId);
			resolve(token);
		};

		timeoutId = window.setTimeout(() => {
			options.onTimeout?.();
			settle(null);
		}, options.timeoutMs ?? DEFAULT_TIMEOUT_MS);

		try {
			client.ready(() => {
				if (isSettled) {
					return;
				}

				Promise.resolve(client.execute(options.siteKey, {action: options.action}))
					.then(token => {
						settle(token || null);
					})
					.catch((error: unknown) => {
						options.onError?.(error);
						settle(null);
					});
			});
		} catch (error) {
			options.onError?.(error);
			settle(null);
		}
	});
}
